import { colors } from '@material-ui/core'

export default (palette, isDarkMode) => ({
  root: {
    color: palette.icon,
    '&:hover': {
      backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.05)' : colors.grey[100],
    },
    '&$selected': {
      backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.1)' : colors.grey[50],
      color: palette.primary.main,
      '&:hover': {
        backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.15)' : colors.grey[100],
      },
    },
    '&:first-child': {
      borderTopLeftRadius: 4,
      borderBottomLeftRadius: 4,
    },
    '&:last-child': {
      borderTopRightRadius: 4,
      borderBottomRightRadius: 4,
    },
  },
})
